'use strict';

var A="afa-shared";

exports.a = A;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-32OAM7MJ.js.map